// Multi-seleção de setores do custo (pessoa e kit). Devolve frações IGUAIS: pesos
// diferentes não têm tela nesta etapa, de propósito (menos erro).
import { Select } from 'antd';
import { SETORES } from '../pages/financeiro-contas-receber/utils';
import { chavesOrdenadas, fracoesIguais, type FracoesSetores } from '../pages/administrativo-plano-acao/paginas/dadosSetoresCusto';

export { fracoesIguais, rotuloSetores } from '../pages/administrativo-plano-acao/paginas/dadosSetoresCusto';

const OPCOES = Object.keys(SETORES)
  .sort((a, b) => SETORES[a].ordem - SETORES[b].ordem)
  .map((k) => ({ value: k, label: SETORES[k].rotulo, cor: SETORES[k].cor }));

export default function SeletorSetores({ value, onChange, disabled, placeholder, style }: {
  value?: FracoesSetores | null;
  onChange?: (novo: FracoesSetores | null) => void;
  disabled?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
}) {
  return (
    <Select
      mode="multiple" showSearch optionFilterProp="label" allowClear
      disabled={disabled} style={{ width: '100%', ...style }}
      placeholder={placeholder || 'Sem setor: segue a mistura do contrato'}
      value={chavesOrdenadas(value)}
      onChange={(chaves: string[]) => onChange?.(fracoesIguais(chaves))}
      options={OPCOES}
      optionRender={(o) => (
        <span>
          <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: (o.data as any).cor, marginRight: 8 }} />
          {o.label}
        </span>
      )}
    />
  );
}
